import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { PushGADataLayer } from '../../utils/helpers'

const myCustomStyle = {
  fill: true,
  fillColor: '#eee',
  fillOpacity: 1,
  stroke: true,
  weight: 0,
  opacity: 1,
  color: "#F6F6F6"
}

let markers = {}
let currentClickedMarker = null

export const LeafletMap = async (mapContainer, geojson = '', pin = '', pinSelected = '', networkJson, handleSelectedStation, resetSelectedStation, featureType) => {
  // Create a default icon 
  const defaultIcon = L.icon({
    iconUrl: pin,
    iconSize: [20, 20],
    popupAnchor: [1, -35]
  });
  // Create a selected icon 
  const selectedIcon = L.icon({
    iconUrl: pinSelected,
    iconSize: [40, 40],
    iconAnchor: [20, 38],
  });

  
  const map = L.map(mapContainer.current, {
    minZoom: 2,
    maxZoom: 8,
  })
    .setView([17.39463998114266, 57.68586837100877], 3);


  //   L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //   maxZoom: 19
  // }).addTo(map);

  /* zoom control position */
  map.zoomControl.setPosition('topright');

  // request geojson
  const geoJson = await fetch(geojson)
    .then(data => data.json())
    .then(json => json)
  // // request network map
  // const networkJson = await fetch(networkMap)
  //   .then(data => data.json())
  //   .then(json => json)


  L.geoJson(geoJson, {
    clickable: false,
    style: myCustomStyle
  }).addTo(map);

  const groundHandlingFeatureEnable = featureType === "networkbyairport" ? true :false;
  const networkByLocalOfficeFeatureEnable = featureType === "networkbylocaloffice" ? true :false;

  networkJson?.data.forEach(singleNetwork => {
    singleNetwork.stations.forEach(station => {
      const { latitude, longitude, place, airport } = station
      const marker = L.marker([parseInt(latitude), parseInt(longitude)], { icon: defaultIcon })
        .bindPopup(groundHandlingFeatureEnable ? airport : place , {
          closeButton: false
        })
        .addTo(map);

      function handleMarkerClick(e) {
        const isFromSearch = e.isFromSearch;
        if (marker === currentClickedMarker) {
          // Clicked on the same marker, toggle its state
          if (marker.getIcon() === selectedIcon) {
            marker.setIcon(defaultIcon);
            // reset selected station
            resetSelectedStation()
          } else {
            marker.setIcon(networkByLocalOfficeFeatureEnable ? defaultIcon : selectedIcon);
            handleSelectedStation(e, networkJson?.data, false, groundHandlingFeatureEnable)
            if(!isFromSearch){
              PushGADataLayer('Contact Us', 'Location Map Clicks', airport + ' : ' + place);
            }
          }
        } else {
          // Clicked on a different marker, reset the previously clicked marker
          if (currentClickedMarker !== null) {
            currentClickedMarker.setIcon(defaultIcon);
            // reset selected station
            resetSelectedStation()
          }
          // Set the clicked marker's icon to the clicked state and update currentClickedMarker
          marker.setIcon(selectedIcon);
          handleSelectedStation(e, networkJson?.data, false, groundHandlingFeatureEnable)
          if(!isFromSearch){
            PushGADataLayer('Contact Us', 'Location Map Clicks', airport + ' : ' + place);
          }
          currentClickedMarker = marker;
        }
      }

      function switchDefault() {
        marker.setIcon(defaultIcon);
        resetSelectedStation()
      }

      // Handle the click event to change the icon
      marker.on('click', handleMarkerClick);
      map.on('click', switchDefault)
      
      if(groundHandlingFeatureEnable){
        markers[[airport]] = marker
      }
      else{
        markers[[place]] = marker
      }
      

    });
  })
  return
}

/* handle Marker Auto Select from Search */
export const handleMarkerAutoSelect = (selectedStation, isGroundHandlingFeatureEnable, isFromSearch=false) => {
  if (selectedStation) {
    const { place = '', airport = '' } = selectedStation
    if(isGroundHandlingFeatureEnable){
      markers[airport].fire('click',{isFromSearch: isFromSearch})
    }
    else{
      markers[place].fire('click',{isFromSearch: isFromSearch})
    }
  }
  return
}

/* reset selected station */
export const resetMapPin = () => {
  if (currentClickedMarker) {
    currentClickedMarker.fire('click')
    currentClickedMarker = null
  }
}